const MessageType = {
    WHOAMI: 'WHOAMI',
    USERINFO: 'USERINFO',
	JOINED: 'JOINED',
	LEFT: 'LEFT',
	TEXT: 'TEXT',
	OPTIONS: 'OPTIONS',
	CHOSENOPTION: 'CHOSENOPTION',
	IMAGE: 'IMAGE',
	LINK: 'LINK',
	JOIN: 'JOIN',
	LEAVE: 'LEAVE',
	QUERYCHATROOMS: 'QUERYCHATROOMS', 
	HISTORY: 'HISTORY',
};

export default MessageType;
